import React from "react";

import {
  ChannelType,
  DeviceType,
  StatSigViewType,
  VisitorType,
} from "@intelligems/ig-types";

import { Device } from "../AudienceFilters/Device/Device";

interface DeviceTypeFilterProps {
  onStringFilterChange: (
    newValue: DeviceType | VisitorType | ChannelType | StatSigViewType,
    filterKey: "statSigView" | "deviceType" | "channelType" | "visitorType"
  ) => void;
  deviceType?: DeviceType | null;
}

export const DeviceTypeFilter = ({
  deviceType,
  onStringFilterChange,
}: DeviceTypeFilterProps) => {
  return (
    <Device deviceType={deviceType || "any"} onClick={onStringFilterChange} />
  );
};
